export const task = {
  routes: [
    {
      path: "/tasks",
      component: () => import("../tasks"),
    },
    {
      path: "/tasks/dashboard",
      component: () => import("../tasks"),
    },
    {
      path: "/tasks/archived",
      component: () => import("../archived-tasks"),
    },
  ],
};

export const platform = {
  routes: [
    {
      path: "/account-tasks",
      component: () => import("../account-tasks"),
    },
    {
      path: "/account-tasks/:id",
      component: () => import("../account-tasks"),
    },
    {
      path: "/account-tasks/archived",
      component: () => import("../account-archived-tasks"),
    },
  ],
};

export const organization = {
  routes: [
    {
      path: "/organization/tasks",
      component: () => import("../organization-tasks"),
    },
    {
      path: "/organization/tasks/archived",
      component: () => import("../organization-archived-tasks"),
    },
  ],
};

export const management = {
  routes: [
    {
      path: "/management/task-category",
      component: () => import("../task-category/management-library-task-category-view"),
    },
  ],
};
export const workspace = {
  routes: [
    {
      path: "/workspace/library/task-category",
      component: () => import("../task-category/workspace-library-task-category-view"),
    },
  ],
};
